import update from 'immutability-helper';
import _ from 'lodash';
import reduceReducers from 'reduce-reducers';
import I18n from 'app/common/i18n';
import {skills, candidates, getCandidateProfile} from 'app/client/api';
import {showAppBusy, handleAppError} from './app';


const initialState = {
	filter: {
		skills: ''
	},
	skills: [],
	candidates: [],
  candidatesCount: {
    totalCount: 0,
    timePeriodBasedCount: 0
  },
  searched: false,
  candidateProfile: {}
}

const UPDATE_FILTER = 'candidates/UPDATE_FILTER';
const RECEIVE_SKILLS = 'candidates/RECEIVE_SKILLS';
const RECEIVE_CANDIDATES = 'candidates/RECEIVE_CANDIDATES';
const RECEIVE_TOTAL_CANDIDATES_COUNT = 'candidates/RECEIVE_TOTAL_CANDIDATES_COUNT';
const RECEIVE_TIME_PERIOD_BASED_CANDIDATES_COUNT = 'candidates/RECEIVE_TIME_PERIOD_BASED_CANDIDATES_COUNT';
const UPDATE_SEARCHED = 'candidates/UPDATE_SEARCHED';
const RECEIVE_CANDIDATE_PROFILE = 'candidate/RECEIVE_CANDIDATE_PROFILE';

export function receiveCandidateProfile(payload) {
  return {type: RECEIVE_CANDIDATE_PROFILE, payload}
}

export function receiveCandidatesCount(count, timePeriod) {
  if(timePeriod) {
    return {type: RECEIVE_TIME_PERIOD_BASED_CANDIDATES_COUNT, payload: count}
  }
  return {type: RECEIVE_TOTAL_CANDIDATES_COUNT, payload: count}
}

function receiveSkills(payload) {
	return {type: RECEIVE_SKILLS, payload}
}

function receiveCandidates(payload) {
	return {type: RECEIVE_CANDIDATES, payload}
}

export function updateFilter(payload) {
	return {type: UPDATE_FILTER, payload}
}

export function updateSearched(payload) {
  return {type: UPDATE_SEARCHED, payload}
}

export function fetchSkills() {
  return async dispatch => {
  	dispatch(showAppBusy(true));
    try {
      let response = await skills();
      dispatch(receiveSkills(response.data.skills));
      dispatch(showAppBusy(false));
    } catch(exception) {
    	dispatch(showAppBusy(false));
    	dispatch(handleAppError(exception, I18n.t('errors.unexpected')));
    }
  }
}

export function getRequestQuery(query, assessmentId, index) {
  if (index === 0)
    return `assessmentId=${assessmentId}`;
  return `${query}&assessmentId=${assessmentId}`;
}

export function fetchCandidates() {
  return async (dispatch, getState) => {
  	dispatch(showAppBusy(true));
    let skills = getState().candidates.filter.skills;
    let assessmentIds = _.map(skills, 'id');
    let query = '';
    assessmentIds.map((assessmentId, index) => {
      query = getRequestQuery(query, assessmentId, index);
    });
    try {
      let response = await candidates(query);
      dispatch(receiveCandidates(response.data.studentReports));
      dispatch(updateSearched(true));
      dispatch(showAppBusy(false));
    } catch(exception) {
    	dispatch(showAppBusy(false));
    	dispatch(handleAppError(exception, I18n.t('errors.unexpected')));
    }
  }
}

export function fetchCandidateProfile(candidateId) {
  return async (dispatch) => {

    if (!candidateId) {
      return;
    }
    
    try {
      let response = await getCandidateProfile(candidateId);
      dispatch(receiveCandidateProfile(response.data))
    } catch(exception) {
        dispatch(handleAppError(exception, I18n.t('errors.unexpected')));
    }
  }
}

export default function reducer(state = initialState, action) {
	let {	type, payload	} = action;
	switch(type)	{

		case RECEIVE_SKILLS:
			return update(state, {skills: { $set: payload }});

		case RECEIVE_CANDIDATES:
			return update(state, {candidates: { $set: payload }});

		case UPDATE_FILTER:
			return update(state, {filter: { $set: payload }});

    case RECEIVE_TOTAL_CANDIDATES_COUNT:
      return update(state, {candidatesCount: {totalCount: {$set: payload} } });

    case RECEIVE_TIME_PERIOD_BASED_CANDIDATES_COUNT:
      return update(state, {candidatesCount: {timePeriodBasedCount: {$set: payload} } });

    case UPDATE_SEARCHED: 
      return update(state, {searched: {$set: payload}});

    case RECEIVE_CANDIDATE_PROFILE:
      return update(state, { candidateProfile: { $set: payload } });

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/candidates.js